import { render, staticRenderFns } from "./LastActiveLessonCard.vue?vue&type=template&id=78edbb87&scoped=true&"
import script from "./LastActiveLessonCard.vue?vue&type=script&lang=js&"
export * from "./LastActiveLessonCard.vue?vue&type=script&lang=js&"
import style0 from "./LastActiveLessonCard.vue?vue&type=style&index=0&id=78edbb87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78edbb87",
  null
  
)

export default component.exports